var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ad"},[_c('h2',[_vm._v("在三泰，享高效")]),_c('p',[_vm._v("有一个想法？我们在这里帮助你的工作")]),_c('span',{on:{"click":_vm.goto}},[_vm._v("联系我们")])])}
var staticRenderFns = []

export { render, staticRenderFns }